export enum FieldDataTypeEnum {
    String = 0,
    Int32 = 1,
    Int16 = 2,
    Double = 3,
    Decimal = 4,
    DateTime = 5,
    Boolean = 6,
    Image = 7,
    Time = 8,

    Date = 51,
}
